import { get, isEmpty } from 'ravenjs/utils/lodash';

import { CATEGORY_NAMES, CONTENT_NAMES, NAV_STATE_TYPES } from 'constants/content';

/**
 * Format list of documents for the <DocumentView> component
 *
 * @param   {string}    category
 * @param   {string}    documentType
 * @param   {Array}     documents
 * @return  {Array}
 */
export const formatDocuments = (category, documentType, documents = []) =>
    documents.map(({ contentfulId, status, summary, title, mediaThumbnail }) => ({
        documentType,
        id: contentfulId,
        parent: category,
        status,
        summary,
        thumbNailImg: get(mediaThumbnail, 'file.url', ''),
        title,
    }));

/**
 * Format documents based on the group(category)
 *
 * @param   {Object}    documentsObj
 * @param   {Array}     categories
 * @param   {string}    documentType
 * @return {Array}
 */
export const formatDocumentsByGroup = (documentsObj, categories, documentType) => {
    const getCategoryId = categoryName => {
        return categories.find(({ name }) => name === categoryName).id;
    };

    return Object.entries(documentsObj).map(([category, documents]) => {
        return {
            id: getCategoryId(category),
            // TODO: Add color based on the response from the API
            color: 'transparent',
            title: category,
            totalDocuments: documents.length,
            documents: formatDocuments(category, documentType, documents),
        };
    });
};

export const formatCategoriesAndSubcategories = listCategories => {
    const parentCategories = [];

    if (!isEmpty(listCategories)) {
        listCategories.forEach(item => {
            if (isEmpty(parentCategories.find(option => option.id === item.parentId))) {
                parentCategories.push({
                    color: item.bulletColor,
                    id: item.parentId,
                    name: item.parentName,
                });
            }
        });

        parentCategories.map(item => {
            item.subcategories = listCategories.filter(
                option => option.parentId === item.id && option.id !== option.parentId
            );
            return item;
        });
    }

    return parentCategories;
};

export const getStatesByDocument = (states, state) => {
    let list = '';

    if (!isEmpty(states)) {
        list = states.map(item => {
            return item.name;
        });

        list = list.join(', ');
    } else if (typeof state === 'string') {
        if (state === 'All') {
            list = 'All States';
        } else if (state !== 'N/A') {
            list = state;
        }
    }

    return list;
};

export const getFormattedCategories = (categoriesResponse, buildUpdatedFilter) => {
    const categories = get(categoriesResponse, 'data.categories', []);
    // TODO: remove filter when API no longer returns Other
    const categoryTypesData = {
        ...categoriesResponse,
        categories: categories.filter(category => category.name !== CATEGORY_NAMES.OTHER),
    };
    const contentTypeNames = get(categoryTypesData, 'categories', []);
    const categoryTypeNamesFilter = buildUpdatedFilter(categoryTypesData, 'categories', 1);
    categoryTypeNamesFilter.rowsPerColumn = Math.ceil(categoryTypeNamesFilter.options.length / 2);

    return { categories, categoryTypeNamesFilter, contentTypeNames };
};

export const formatRoute = route => {
    return route
        ? route
              .toLowerCase()
              .replace(/ /g, '-')
              .replace('&', 'and')
        : null;
};

export const getRoutesForDocumentType = documentTypeLabel => {
    let documentTypeRoute;
    switch (documentTypeLabel) {
        case CONTENT_NAMES.POLICY:
            documentTypeRoute = formatRoute(NAV_STATE_TYPES.POLICY);
            break;
        case CONTENT_NAMES.CHECKLIST:
            documentTypeRoute = formatRoute(NAV_STATE_TYPES.CHECKLIST);
            break;
        default:
            documentTypeRoute = formatRoute(documentTypeLabel);
            break;
    }
    return documentTypeRoute;
};
